import React from "react";
import { NavLink } from "react-router-dom";

const ADMIN_ROUTES = [
  {
    key: "master-data",
    label: "Master Data",
    path: "/admin/master-data",
    icon: "🧾",
    tooltip: "Manage approved master data entities",
  },
  {
    key: "users",
    label: "Users",
    path: "/admin/users",
    icon: "👥",
    tooltip: "View and audit user accounts",
  },
  {
    key: "billing",
    label: "Billing",
    path: "/admin/billing/transactions",
    icon: "💳",
    tooltip: "Review billing transactions and approvals",
  },
  {
    key: "reports",
    label: "Reports Status",
    path: "/admin/reports/status",
    icon: "📄",
    tooltip: "Monitor report generation status",
  },
  {
    key: "analysis",
    label: "Analysis Errors",
    path: "/admin/analysis/errors",
    icon: "⚠️",
    tooltip: "Inspect analysis errors and failures",
  },
];

export default function AdminNavigation({ showBadges = false }) {
  return (
    <div className="card p-4">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-slate-900">Admin Modules</h2>
        <span className="text-xs text-slate-500">Quick access</span>
      </div>

      <div className="mt-4 hidden gap-3 lg:grid lg:grid-cols-5">
        {ADMIN_ROUTES.map((route) => (
          <NavLink
            key={route.key}
            to={route.path}
            title={route.tooltip}
            data-testid={`admin-nav-${route.key}`}
            className={({ isActive }) =>
              `group flex flex-col gap-2 rounded-xl border border-slate-200 px-3 py-3 text-sm transition ${
                isActive
                  ? "bg-amber-50 text-amber-700"
                  : "bg-white text-slate-700 hover:bg-slate-50"
              }`
            }
          >
            <div className="flex items-center justify-between">
              <span className="text-lg" aria-hidden="true">
                {route.icon}
              </span>
              {showBadges && (
                <span className="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-500">
                  —
                </span>
              )}
            </div>
            <div className="font-semibold">{route.label}</div>
            <div className="text-xs text-slate-500">{route.tooltip}</div>
          </NavLink>
        ))}
      </div>

      <div className="mt-4 flex gap-3 overflow-x-auto pb-1 lg:hidden">
        {ADMIN_ROUTES.map((route) => (
          <NavLink
            key={route.key}
            to={route.path}
            title={route.tooltip}
            data-testid={`admin-nav-${route.key}`}
            className={({ isActive }) =>
              `flex min-w-[160px] flex-col gap-2 rounded-xl border border-slate-200 px-3 py-3 text-sm transition ${
                isActive
                  ? "bg-amber-50 text-amber-700"
                  : "bg-white text-slate-700 hover:bg-slate-50"
              }`
            }
          >
            <div className="flex items-center justify-between">
              <span className="text-lg" aria-hidden="true">
                {route.icon}
              </span>
              {showBadges && (
                <span className="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-500">
                  —
                </span>
              )}
            </div>
            <div className="font-semibold">{route.label}</div>
            <div className="text-xs text-slate-500">{route.tooltip}</div>
          </NavLink>
        ))}
      </div>
    </div>
  );
}
